var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ButtonAFY, InputAFY, ModalComponentAFY, SelectAFY, sizes, sizesSelect, sizesTextField, typeAlert, variants, variantsTextField, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import * as catalogConst from "../../const/catalog";
import { STEP_CLIENTRECORD } from "../../const/catalog";
import { stepProgress } from "../../dataBase/stepProgress";
import LocalStorageService from "../../services/localStorage";
import showToast from "../../services/toast";
import { quoteAll, quoteAllClearData } from "../../store/generateQuote/actions";
import { identificationType } from "../../store/identificationType/actions";
import { personById, personByIdClearData } from "../../store/person/actions";
import { policyCancelClearData } from "../../store/policy/actions";
import { cancelQuoteClearData } from "../../store/cancelQuote/actions";
import { formattedDate } from "../../utils/date";
import { GetCatalogsType } from "../../fnx/catalog/getCatalogsType";
import { getCatalogsTypeClearData } from "../../store/catalog/actions";
import { showErrorToast } from "../../fnx/showError";
import { showToastSuccessMessage } from "../../fnx/sendSuccessMessage";
import { useTranslation } from "react-i18next";
import { beneficiaryColumns, Columns, insuredColumns, } from "./resources/clientRecordDTO";
import "./assets/style.css";
import { ClientRecordView } from "./ui/view";
import useSelectors from "./components/selectors";
import useUI from "./components/ui";
import useClientRecord from "./components/clientRecord";
import { ClientRecordHeader } from "./ui/header";
import { Modal } from "./ui/modals";
import PagesHeader from "ah_utility/PagesHeader";
import { useGetSteps } from "../../utils/getSteps";
import { useGetSummary } from "../../utils/getSummary";
import { buildAndSaveWorkflowSteps, useGetInformationSteps, } from "ah_utility/workflow";
import { useCompleteStep } from "../../utils/responseComplete";
import { useStyles } from "./assets/style";
import { getUserNameFromStorage, validatePassword, } from "ah_utility/AuthValidation";
import { GetProjectOne } from "../../fnx/project/projectOne";
import { useGetWokFlow } from "../../fnx/workFlow/getWorkFlow";
import { projectOneClearData } from "../../store/project/actions";
import { getWorkFlowClearData } from "../../store/workFlow/actions";
var storageKey2 = "assurehub";
var lsLogin = new LocalStorageService(storageKey2);
export var ClientRecordPage = function () {
    var STEP = STEP_CLIENTRECORD;
    var dispatch = useDispatch();
    var navigate = useNavigate();
    var classes = useStyles();
    var id = useParams().id;
    var _a = React.useState(true), enable = _a[0], setEnable = _a[1];
    var _b = React.useState(1), page = _b[0], setPage = _b[1];
    var company = React.useState(lsLogin.getUserLoginStored().subdomain || "")[0];
    var _c = useState(getUserNameFromStorage() || ""), userName = _c[0], setUserName = _c[1];
    var _d = useState(""), userNameError = _d[0], setUserNameError = _d[1];
    var _e = useState(""), password = _e[0], setPassword = _e[1];
    var _f = useState(false), isValidating = _f[0], setIsValidating = _f[1];
    var _g = useState(""), passwordError = _g[0], setPasswordError = _g[1];
    var _h = useState(""), currentPersonId = _h[0], setCurrentPersonId = _h[1];
    var _j = React.useState(false), triggerPermissionList = _j[0], setTriggerPermissionList = _j[1];
    var _k = React.useState(5000), limit = _k[0], setLimit = _k[1];
    var _l = useState(false), showInfo = _l[0], setShowInfo = _l[1];
    var _m = useState([]), clientInfo = _m[0], setClientInfo = _m[1];
    var _o = useState([]), rowsQuote = _o[0], setRowsQuote = _o[1];
    var _p = useState(false), showBeneficiariesModal = _p[0], setShowBeneficiariesModal = _p[1];
    var _q = useState(false), openModalReason = _q[0], setOpenModalReason = _q[1];
    // const [steps, setSteps] = React.useState<MenuItem[]>([]);
    var _r = useState(false), showInsuredModal = _r[0], setShowInsuredModal = _r[1];
    var _s = useState([]), beneficiariesRows = _s[0], setBeneficiariesRows = _s[1];
    var _t = useState([]), insuredRows = _t[0], setInsuredRows = _t[1];
    var _u = useState(""), documentNumber = _u[0], setDocumentNumber = _u[1];
    var _v = useState(""), documentType = _v[0], setDocumentType = _v[1];
    var _w = useState([]), filtersII = _w[0], setFiltersII = _w[1];
    var _x = React.useState([]), breadCrumbs = _x[0], setBreadCrumbs = _x[1];
    var _y = useState(true), showNextDisabled = _y[0], setShowNextDisabled = _y[1];
    var storageKeyVariables = "afy-variables";
    var lsVariables = new LocalStorageService(storageKeyVariables);
    var _z = useState(""), documentName = _z[0], setDocumentName = _z[1];
    var _0 = useCompleteStep(), runComplete = _0.runComplete, loadingComplete = _0.loadingComplete, responseComplete = _0.responseComplete, errorComplete = _0.errorComplete;
    var _1 = useState(false), openModalConfirm = _1[0], setOpenModalConfirm = _1[1];
    var _2 = useState([]), reasonCancellation = _2[0], setReasonCancellation = _2[1];
    var _3 = useState(""), policyId = _3[0], setPolicyId = _3[1];
    var _4 = useState(true), type = _4[0], setType = _4[1]; //cotizacion = false o poliza = true
    var _5 = useState(""), codigo = _5[0], setCodigo = _5[1];
    var _6 = useState(""), status = _6[0], setStatus = _6[1];
    var _7 = useState("Póliza"), modalTitle = _7[0], setModalTitle = _7[1];
    var _8 = useState(false), triggerCatalogs = _8[0], setTriggerCatalogs = _8[1];
    var t = useTranslation().t;
    var _9 = useState(null), dataAddress = _9[0], setDataAddress = _9[1];
    var _10 = useState([]), listIdentificationType = _10[0], setListIdentificationType = _10[1];
    var _11 = React.useState({
        show: false,
        message: "",
        type: typeAlert.success,
    }), seeToast = _11[0], setSeeToast = _11[1];
    var pathname = useLocation().pathname;
    var pathLocation = "/" + pathname.split("/")[1];
    var _12 = React.useState({}), sessionData = _12[0], setSessionData = _12[1];
    var _13 = React.useState(false), triggerWorkflow = _13[0], setTriggerWorkflow = _13[1];
    var _14 = React.useState(""), workflowId = _14[0], setWorkflowId = _14[1];
    var summary = useGetSummary();
    var _15 = useSelectors(), responsePerson = _15.responsePerson, errorPerson = _15.errorPerson, responseAllQuote = _15.responseAllQuote, responseIdentificationType = _15.responseIdentificationType, responseBeneficiary = _15.responseBeneficiary, responseInsured = _15.responseInsured, loadingPerson = _15.loadingPerson, loadingIdentificationType = _15.loadingIdentificationType, loadingBeneficiary = _15.loadingBeneficiary, responseCancelPolicy = _15.responseCancelPolicy, errorCancelPolicy = _15.errorCancelPolicy, loadingCancelPolicy = _15.loadingCancelPolicy, responseCancelQuote = _15.responseCancelQuote, errorCancelQuote = _15.errorCancelQuote, loadingCancelQuote = _15.loadingCancelQuote, loadingAllQuote = _15.loadingAllQuote;
    var _16 = useClientRecord(setShowNextDisabled, setDocumentType, setDocumentName, setDocumentNumber, documentNumber, setSeeToast, typeAlert, listIdentificationType, lsVariables, documentType), handleChange = _16.handleChange, handleChangeSelect = _16.handleChangeSelect, handleSearch = _16.handleSearch, isValid = _16.isValid, validDocument = _16.validDocument;
    var _17 = useGetInformationSteps(pathLocation), instanceId = _17.instanceId, workFlowId = _17.workFlowId, currentStep = _17.currentStep, nextStep = _17.nextStep;
    var _18 = useUI(setShowBeneficiariesModal, setShowInsuredModal, id, STEP, isValid, setSeeToast, setOpenModalConfirm, setPolicyId, setType, setCodigo, setStatus, setModalTitle, setTriggerCatalogs, instanceId || "", workFlowId || "", currentStep || "", nextStep || "", runComplete, sessionData, dataAddress, documentNumber, documentType), handleClickContextMenu = _18.handleClickContextMenu, handleClickNext = _18.handleClickNext, handleClickPrevious = _18.handleClickPrevious, handleCancelPolicy = _18.handleCancelPolicy, isNextDisabled = _18.isNextDisabled, projectId = _18.projectId, triggerProject = _18.triggerProject, dataRow = _18.dataRow;
    var _19 = GetCatalogsType(triggerCatalogs, enable, page, limit, catalogConst.CATALOG_REASON_CANCELLATION), responseGetCatalogsType = _19.responseGetCatalogsType, loadingGetCatalogsType = _19.loadingGetCatalogsType, errorGetCatalogsType = _19.errorGetCatalogsType;
    var _20 = GetProjectOne(triggerProject, projectId), responseOneProject = _20.responseOneProject, errorOneProject = _20.errorOneProject, loadingOneProject = _20.loadingOneProject;
    var _21 = useGetWokFlow(triggerWorkflow, workflowId, function () { return setTriggerWorkflow(false); }), loadingWorkFlow = _21.loadingWorkFlow, responseWorkFlow = _21.responseWorkFlow, errorWorkflow = _21.errorWorkflow;
    useEffect(function () {
        dispatch(personByIdClearData());
        dispatch(quoteAllClearData());
        dispatch(identificationType({ enable: enable, page: page, limit: limit }));
        setBreadCrumbs(stepProgress(STEP, true));
        // setSteps(stepProgress(STEP));
        // Comes from the client page
        if (id) {
            setDocumentNumber(id);
            dispatch(
            //personById({ enable: enable, page: page, limit: limit, numberId: id }),
            personById(id));
        }
    }, []);
    useEffect(function () {
        var _a;
        if (responseOneProject) {
            var alterWorkflow = (_a = responseOneProject === null || responseOneProject === void 0 ? void 0 : responseOneProject.workflows) === null || _a === void 0 ? void 0 : _a.find(function (workflow) { return workflow.page === "alter_flow"; });
            if (!alterWorkflow) {
                showToastSuccessMessage("El producto no tiene un flujo de venta alterno asociado", typeAlert.warning, setSeeToast);
            }
            else {
                setWorkflowId(alterWorkflow.id);
                localStorage.setItem("WorkFlowId", alterWorkflow.id);
                setTriggerWorkflow(true);
            }
            dispatch(projectOneClearData());
        }
    }, [responseOneProject]);
    useEffect(function () {
        var _a, _b, _c, _d, _e, _f;
        if (responseWorkFlow) {
            var nodes = (_b = (_a = responseWorkFlow.draftDataMap) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.nodes;
            var edges = (_d = (_c = responseWorkFlow.draftDataMap) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.edges;
            buildAndSaveWorkflowSteps(nodes, edges, "steps", true);
            navigate("/confirmationForm/".concat((_e = dataRow === null || dataRow === void 0 ? void 0 : dataRow.id) !== null && _e !== void 0 ? _e : "", "/true/false/").concat((_f = dataRow === null || dataRow === void 0 ? void 0 : dataRow.productId) !== null && _f !== void 0 ? _f : ""));
        }
        dispatch(getWorkFlowClearData());
    }, [responseWorkFlow]);
    // Handle cancel policy error
    useEffect(function () {
        if (errorCancelPolicy) {
            showErrorToast(errorCancelPolicy, setSeeToast, t);
            dispatch(policyCancelClearData());
        }
    }, [errorCancelPolicy, dispatch]);
    useEffect(function () {
        var _a, _b;
        if (errorPerson) {
            if (((_b = (_a = errorPerson.errors) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.code) === 404) {
                setShowInfo(false);
                setShowNextDisabled(validDocument(documentName, documentNumber) ? false : true);
                setSeeToast({
                    show: true,
                    message: "¡No se encontraron datos para la busqueda!",
                    type: typeAlert.info,
                });
            }
        }
    }, [errorPerson]);
    useEffect(function () {
        if (errorComplete) {
            setSeeToast({
                show: true,
                message: errorComplete.message,
                type: typeAlert.error,
            });
        }
    }, [errorComplete]);
    useEffect(function () {
        var _a;
        if (responsePerson) {
            setShowInfo(true);
            setCurrentPersonId(responsePerson.clientId);
            var addressData = {
                providence: responsePerson.catalogRegionLevel1,
                town: responsePerson.catalogRegionLevel2,
                sector: responsePerson.catalogRegionLevel3,
                address: responsePerson.addressA,
            };
            setDataAddress(addressData);
            // Actualizar sessionData con toda la estructura de datos
            setSessionData({
                additionalContentMap: (responsePerson === null || responsePerson === void 0 ? void 0 : responsePerson.additionalContentMap) || {},
                clientId: responsePerson.clientId,
                numberId: responsePerson.numberId,
                personData: responsePerson,
            });
            if (!((_a = responsePerson === null || responsePerson === void 0 ? void 0 : responsePerson.additionalContentMap) === null || _a === void 0 ? void 0 : _a.accounts)) {
                setSeeToast({
                    show: true,
                    message: "¡La persona no es cliente del banco!",
                    type: typeAlert.warning,
                });
            }
            dispatch(quoteAll({
                clientId: responsePerson.clientId,
                enable: enable,
                page: page,
                limit: limit,
                numberId: responsePerson.numberId,
                fields: "abc",
            }));
            setClientInfo([
                {
                    label: "Nombre completo",
                    value: responsePerson.lastNameA +
                        " " +
                        responsePerson.lastNameB +
                        ", " +
                        responsePerson.firstNameA +
                        " " +
                        responsePerson.firstNameB,
                },
                {
                    label: "Fecha de nacimiento",
                    value: formattedDate(responsePerson.dob),
                },
                {
                    label: "Identificación",
                    value: documentNumber ? documentNumber : responsePerson.numberId,
                },
                { label: "Teléfono casa", value: responsePerson.phone1 },
                { label: "Email", value: responsePerson.email },
                { label: "Dirección", value: responsePerson.addressA },
            ]);
        } /* else {
          if (responsePerson === null) {
            setShowInfo(false);
            setShowNextDisabled(true);
            setSeeToast({
              show: true,
              message: "¡No se encontraron datos para la busqueda!",
              type: typeAlert.info,
            });
          }
        } */
        if (id) {
            setShowNextDisabled(true);
        }
        else {
            setShowNextDisabled(validDocument(documentName, documentNumber) ? false : true);
        }
        dispatch(personByIdClearData());
    }, [responsePerson]);
    // Handle cancel policy response
    useEffect(function () {
        if (responseCancelPolicy &&
            typeof responseCancelPolicy === "object" &&
            responseCancelPolicy !== true) {
            showToastSuccessMessage("Póliza cancelada exitosamente", typeAlert.success, setSeeToast);
            dispatch(policyCancelClearData());
            // Refresh the quotes list with current values
            var currentClientId = currentPersonId;
            var _term = documentNumber;
            _term = _term.replace(/-/g, "");
            _term = _term.replace(/_/g, "");
            if (_term && currentClientId) {
                dispatch(quoteAll({
                    clientId: currentClientId,
                    enable: enable,
                    page: page,
                    limit: limit,
                    numberId: _term,
                    fields: "abc",
                }));
            }
        }
    }, [responseCancelPolicy, dispatch]);
    // Handle cancel quote response
    useEffect(function () {
        if (responseCancelQuote &&
            typeof responseCancelQuote === "object" &&
            responseCancelQuote !== true) {
            showToastSuccessMessage("Cotización cancelada exitosamente", typeAlert.success, setSeeToast);
            dispatch(cancelQuoteClearData());
            // Refresh the quotes list with current values
            var currentDocumentNumber = documentNumber;
            var currentClientId = currentPersonId;
            var _term = documentNumber;
            _term = _term.replace(/-/g, "");
            _term = _term.replace(/_/g, "");
            console.log("asdf", currentDocumentNumber, currentClientId);
            if (currentDocumentNumber && currentClientId) {
                setOpenModalConfirm(false);
                dispatch(quoteAll({
                    clientId: currentClientId,
                    enable: enable,
                    page: page,
                    limit: limit,
                    numberId: _term,
                    fields: "abc",
                }));
            }
        }
    }, [responseCancelQuote, dispatch]);
    // Handle cancel quote error
    useEffect(function () {
        if (errorCancelQuote) {
            showErrorToast(errorCancelQuote, setSeeToast, t);
            dispatch(cancelQuoteClearData());
        }
    }, [errorCancelQuote, dispatch]);
    useEffect(function () {
        setRowsQuote([]);
        if (responseAllQuote && (responseAllQuote === null || responseAllQuote === void 0 ? void 0 : responseAllQuote.length) > 0) {
            var srq = [];
            responseAllQuote.map(function (item) {
                var _a, _b, _c, _d, _e, _f, _g, _h;
                var prima = ((_a = item.lastPrice) === null || _a === void 0 ? void 0 : _a.currencySymbol) + " " + ((_b = item.lastPrice) === null || _b === void 0 ? void 0 : _b.amount);
                srq.push({
                    id: item.id,
                    estado: (_c = item.catalogStatusQuote) === null || _c === void 0 ? void 0 : _c.description,
                    cotizacion: item.code,
                    poliza: (_d = item.policyId) === null || _d === void 0 ? void 0 : _d.code,
                    producto: (_e = item.productId) === null || _e === void 0 ? void 0 : _e.description,
                    plan: (_f = item.planId) === null || _f === void 0 ? void 0 : _f.name,
                    policyId: (_g = item.policyId) === null || _g === void 0 ? void 0 : _g.id,
                    prima: prima,
                    productId: (_h = item.productId) === null || _h === void 0 ? void 0 : _h.id,
                    date: item.policyId ? item.policyId.effectiveFrom : item.creationDate,
                });
            });
            setRowsQuote(srq);
        }
    }, [responseAllQuote]);
    useEffect(function () {
        if (showBeneficiariesModal && showInsuredModal) {
            setShowBeneficiariesModal(false);
            setShowInsuredModal(false);
        }
    }, [showBeneficiariesModal, showInsuredModal]);
    useEffect(function () {
        var _a;
        setInsuredRows([]);
        if (responseInsured && ((_a = responseInsured.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            responseInsured.data.map(function (item) {
                setInsuredRows(function (prev) {
                    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
                    return __spreadArray(__spreadArray([], prev, true), [
                        {
                            id: item.id,
                            type: (_a = item.catalogInsuredTypeInfo) === null || _a === void 0 ? void 0 : _a.description,
                            name: (_b = item.personInfo) === null || _b === void 0 ? void 0 : _b.firstNameA,
                            secondName: (_c = item.personInfo) === null || _c === void 0 ? void 0 : _c.firstNameB,
                            lastName: (_d = item.personInfo) === null || _d === void 0 ? void 0 : _d.lastNameA,
                            secondLastName: (_e = item.personInfo) === null || _e === void 0 ? void 0 : _e.lastNameB,
                            marriedName: (_f = item.personInfo) === null || _f === void 0 ? void 0 : _f.marriedName,
                            phone: (_g = item.personInfo) === null || _g === void 0 ? void 0 : _g.phone1,
                            email: (_h = item.personInfo) === null || _h === void 0 ? void 0 : _h.email,
                            dob: (_j = item.personInfo) === null || _j === void 0 ? void 0 : _j.dob,
                        },
                    ], false);
                });
            });
        }
    }, [responseInsured]);
    useEffect(function () {
        var _a;
        setBeneficiariesRows([]);
        if (responseBeneficiary && ((_a = responseBeneficiary === null || responseBeneficiary === void 0 ? void 0 : responseBeneficiary.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            responseBeneficiary.data.map(function (item) {
                setBeneficiariesRows(function (prev) {
                    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
                    return __spreadArray(__spreadArray([], prev, true), [
                        {
                            id: item.id,
                            type: (_a = item.catalogBeneficiaryTypeInfo) === null || _a === void 0 ? void 0 : _a.description,
                            name: (_b = item.personInfo) === null || _b === void 0 ? void 0 : _b.firstNameA,
                            secondName: (_c = item.personInfo) === null || _c === void 0 ? void 0 : _c.firstNameB,
                            lastName: (_d = item.personInfo) === null || _d === void 0 ? void 0 : _d.lastNameA,
                            secondLastName: (_e = item.personInfo) === null || _e === void 0 ? void 0 : _e.lastNameB,
                            marriedName: (_f = item.personInfo) === null || _f === void 0 ? void 0 : _f.marriedName,
                            percentage: item.percentage,
                            phone: (_g = item.personInfo) === null || _g === void 0 ? void 0 : _g.phone1,
                            email: (_h = item.personInfo) === null || _h === void 0 ? void 0 : _h.email,
                            dob: (_j = item.personInfo) === null || _j === void 0 ? void 0 : _j.dob,
                        },
                    ], false);
                });
            });
        }
    }, [responseBeneficiary === null || responseBeneficiary === void 0 ? void 0 : responseBeneficiary.data]);
    useEffect(function () {
        var _a, _b, _c, _d, _e;
        if (responseIdentificationType === null || responseIdentificationType === void 0 ? void 0 : responseIdentificationType.data) {
            var data = (_a = responseIdentificationType.data) === null || _a === void 0 ? void 0 : _a.map(function (identification) {
                return {
                    id: identification.id,
                    value: identification.id,
                    name: identification.description,
                };
            });
            setListIdentificationType(data);
            setDocumentType((_c = (_b = data[0]) === null || _b === void 0 ? void 0 : _b.id) !== null && _c !== void 0 ? _c : "");
            setDocumentName((_e = (_d = data[0]) === null || _d === void 0 ? void 0 : _d.name) !== null && _e !== void 0 ? _e : "");
        }
    }, [responseIdentificationType]);
    useEffect(function () {
        var _a;
        var newMap = (_a = summary === null || summary === void 0 ? void 0 : summary.data) === null || _a === void 0 ? void 0 : _a.map(function (e) { return ({
            name: e.label,
            label: e.value,
            type: "label",
        }); });
        setFiltersII(newMap);
    }, [summary]);
    // Handle catalogs response
    useEffect(function () {
        if (responseGetCatalogsType && Array.isArray(responseGetCatalogsType)) {
            var newArray = responseGetCatalogsType.map(function (item) { return ({
                id: item.id,
                value: item.id,
                name: item.description,
                type: item.code,
            }); });
            setReasonCancellation(newArray);
            setSelectedReasonCancellation(newArray.length > 0 ? newArray[0].value : "");
            dispatch(getCatalogsTypeClearData());
            setTriggerCatalogs(false);
        }
    }, [responseGetCatalogsType, dispatch]);
    var _22 = useState(""), selectedReasonCancellation = _22[0], setSelectedReasonCancellation = _22[1];
    var handleCloseModalConfirm = function () {
        setOpenModalConfirm(false);
    };
    var handleSubmitCancelPolicy = function () {
        if (selectedReasonCancellation) {
            handleCancelPolicy(selectedReasonCancellation, type, policyId);
            // Close modal immediately after submitting
            setOpenModalConfirm(false);
            setOpenModalReason(false);
            setTriggerCatalogs(false);
            setSelectedReasonCancellation("");
        }
    };
    var handleClickSeeDetails = function (data) { };
    var steps = useGetSteps();
    var handleChangeReason = function (value) {
        //setReasonCancellation(value);
        setSelectedReasonCancellation(value);
    };
    var handleUserNameChange = function (value) {
        setUserName(value);
        setUserNameError("");
    };
    var handlePasswordChange = function (value) {
        setPassword(value);
        setPasswordError("");
    };
    var validateAndSubmit = function () { return __awaiter(void 0, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setUserNameError("");
                    setPasswordError("");
                    if (!userName.trim()) {
                        setUserNameError("Debe ingresar el usuario");
                        return [2 /*return*/];
                    }
                    if (!password) {
                        setPasswordError("Debe ingresar la contraseña");
                        return [2 /*return*/];
                    }
                    setIsValidating(true);
                    return [4 /*yield*/, validatePassword(password, userName)];
                case 1:
                    result = _a.sent();
                    if (!result.success) {
                        setPasswordError(result.error || "Error de validación");
                        setIsValidating(false);
                        return [2 /*return*/];
                    }
                    handleSubmitCancelPolicy();
                    setPassword("");
                    setIsValidating(false);
                    return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs(React.Fragment, { children: [_jsx(PagesHeader, { titlePage: "Registro de cliente", hideStep: false, steps: steps }), _jsx(ClientRecordHeader, { loading: loadingPerson ||
                    loadingIdentificationType ||
                    loadingAllQuote ||
                    loadingCancelPolicy ||
                    loadingCancelQuote ||
                    loadingComplete ||
                    loadingOneProject ||
                    loadingWorkFlow, seeToast: seeToast, showToast: showToast, setSeeToast: setSeeToast, id: id, handleClickPrevious: handleClickPrevious }), _jsx(Modal, { title: "Beneficiarios", openModal: showBeneficiariesModal, columns: beneficiaryColumns, rows: beneficiariesRows, close: function () { return setShowBeneficiariesModal(false); } }), _jsx(Modal, { title: "Asegurados", openModal: showInsuredModal, columns: insuredColumns, rows: insuredRows, close: function () { return setShowInsuredModal(false); } }), _jsx(ModalComponentAFY, __assign({ openModal: openModalConfirm, backgroundColor: "#ffffff", onClose: handleCloseModalConfirm, border: 0, minWidthModal: "500px", padding: 30 }, { children: _jsxs("div", __assign({ style: { marginTop: "10px" } }, { children: [_jsxs("h2", __assign({ className: classes.title }, { children: ["Cancelar ", modalTitle] })), _jsx("p", __assign({ className: classes.description }, { children: "\u00BFEst\u00E1 seguro que desea cancelar la ".concat(modalTitle, "?") })), _jsxs("div", __assign({ className: classes.components }, { children: [_jsxs("div", { children: [_jsxs("div", __assign({ className: classes.modalLabel }, { children: [modalTitle, ":"] })), " ", codigo] }), _jsxs("div", { children: [_jsx("div", __assign({ className: classes.modalLabel }, { children: "Estatus:" })), " ", status] })] })), _jsxs("div", __assign({ className: classes.buttonsContainer }, { children: [_jsx("div", __assign({ className: classes.button }, { children: _jsx(ButtonAFY, { variant: variants.contained, size: sizes.large, label: "No", backgroundColor: "red", onClick: handleCloseModalConfirm }) })), _jsx("div", __assign({ className: classes.button }, { children: _jsx(ButtonAFY, { variant: variants.contained, backgroundColor: "rgb(29, 52, 254)", size: sizes.large, label: "Si, cancelar", onClick: function (e) {
                                            e.stopPropagation();
                                            if (type) {
                                                setOpenModalReason(true);
                                            }
                                            else {
                                                handleCancelPolicy(selectedReasonCancellation, type, policyId);
                                            }
                                        } }) }))] }))] })) })), _jsx(ModalComponentAFY, __assign({ openModal: openModalReason, backgroundColor: "#ffffff", onClose: function () { return setOpenModalReason(false); }, border: 0, minWidthModal: "500px", padding: 40 }, { children: _jsxs("div", { children: [_jsx("h2", __assign({ className: classes.title }, { children: "Confirmaci\u00F3n " })), _jsxs("div", __assign({ className: classes.components }, { children: [_jsxs("div", __assign({ className: classes.component }, { children: [_jsx("div", __assign({ className: classes.label }, { children: "Seleccione la razón" })), _jsx(SelectAFY, { value: "", variant: variantsTextField.filled, disableUnderline: true, fontSize: 14, size: sizesSelect.small, options: reasonCancellation, onChange: function (e) {
                                                e.stopPropagation();
                                                handleChangeReason(e.target.value);
                                            } })] })), _jsxs("div", __assign({ className: classes.component }, { children: [_jsx("div", __assign({ className: classes.label }, { children: "Usuario" })), _jsx(InputAFY, { value: userName, fullWidth: true, type: "text", size: sizesTextField.small, variant: variantsTextField.outlined, onChange: function (e) { return handleUserNameChange(e.target.value); }, error: !!userNameError, helperText: userNameError })] })), _jsxs("div", __assign({ className: classes.component }, { children: [_jsx("div", __assign({ className: classes.label }, { children: "Contraseña" })), _jsx(InputAFY, { value: password, fullWidth: true, type: "password", size: sizesTextField.small, variant: variantsTextField.outlined, onChange: function (e) { return handlePasswordChange(e.target.value); }, error: !!passwordError, helperText: passwordError })] }))] })), _jsxs("div", __assign({ className: classes.buttonsContainerConfirm }, { children: [_jsx("div", __assign({ className: classes.button }, { children: _jsx(ButtonAFY, { variant: variants.contained, size: sizes.large, label: "← Atrás", backgroundColor: "red", onClick: function () {
                                            setPassword("");
                                            setPasswordError("");
                                            setUserNameError("");
                                            setOpenModalReason(false);
                                        } }) })), _jsx("div", __assign({ className: classes.button }, { children: _jsx(ButtonAFY, { variant: variants.contained, size: sizes.large, backgroundColor: "rgb(29, 52, 254)", label: isValidating ? "Validando..." : "Si, cancelar", disabled: isValidating, onClick: function (e) {
                                            e.stopPropagation();
                                            validateAndSubmit();
                                        } }) }))] }))] }) })), (listIdentificationType === null || listIdentificationType === void 0 ? void 0 : listIdentificationType.length) > 0 && (_jsx(ClientRecordView, { title: "Registro de cliente", hideFilter: !!id, breadcrumbs: breadCrumbs, stepProgress: steps, previousLabel: "Anterior", nextLabel: "Nueva cotización", nextDisabled: !isNextDisabled //|| (permissions.create ? !showNextDisabled : false)
                , showInfo: showInfo, showBeneficiariesModal: false, showInsuredModal: false, clientInfo: clientInfo, documentTypeList: listIdentificationType, rows: rowsQuote, filters: filtersII, columns: Columns(handleClickContextMenu), handleChange: handleChange, onClickSeeDetails: handleClickSeeDetails, onSearch: handleSearch, handleChangeSelect: handleChangeSelect, onClickNext: handleClickNext, onClickPrevious: handleClickPrevious }))] }));
};
